import { render } from "./ReportsPagination.vue?vue&type=template&id=72d56a98&scoped=true"
import script from "./ReportsPagination.vue?vue&type=script&lang=js"
export * from "./ReportsPagination.vue?vue&type=script&lang=js"

import "./ReportsPagination.vue?vue&type=style&index=0&id=72d56a98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d56a98"]])

export default __exports__